import { Component, Prop, h } from '@stencil/core';

const COMPONENT_NAME = 'banner-type-2';

/**
 * @slot actions - Container for action buttons (1-5 buttons, <me-button variant='tertiary' size='sm'>)
 */

@Component({
  tag: 'banner-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class BannerType2 {
  /**
   * Horizontal content alignment inside the banner: 'left', 'center', or 'right'
   * @default 'end'
   */
  @Prop() align: 'start' | 'center' | 'end' = 'end';

  /**
   * Background color theme. Use 'light' for light backgrounds and 'dark' for dark backgrounds.
   * @type {string}
   * @default 'light'
   * {enum}: ['light', 'dark']
   */
  @Prop() theme: 'light' | 'dark' = 'light';

  render() {
    return (
      <me-section class={`${COMPONENT_NAME} ${COMPONENT_NAME}--${this.theme}`} yGap="2xs" yGapLg="2xs">
        <me-row xGap="none" xGapLg="none" yGap="none" yGapLg="none" justify={`${this.align}`} justifyLg={`${this.align}`}>
          <me-column span="auto">
            <div class={`${COMPONENT_NAME}__actions`}>
              <slot name="actions"></slot>
            </div>
          </me-column>
        </me-row>
      </me-section>
    );
  }
}
